<script>
    import Portal from 'svelte-portal';
    import Panel from './Panel.svelte';

    export let lang, dataset;
    export let urlConfig;

    const { kiboUrl, decoupledUrl } = urlConfig;
    const en = lang != 'fr';
    const Strings = en ? {
        'orderSummary': qty => `Subtotal (${qty} ${qty > 1 ? 'Items' : 'Item'})`,
        'salePrice' : (price, salePrice) => `<strong>$${salePrice?.toFixed(2)}/EA</strong> was $${price?.toFixed(2)}/EA`,
        'cardLinkedSceneText': 'Earn 50 Scene+ points for every $50 spent on eligible purchases (pre-tax)',
        'cardNotLinkedSceneText': 'Add your Scene+ card to earn points on orders over $50 (pre-tax)',
        "quantUnshippable": "Quantity not available to be shipped",
        'quantUnshippableContent': "We're sorry! We can't ship the selected quantity to your home. Please reduce the quantity until Ship to Home appears as an option to continue.",
    } : {
        'orderSummary': qty => `Sous-total (${qty} ${qty > 1 ? 'Objets' : 'Objet'})`,
        'salePrice' : (price, salePrice) => `<strong>$${salePrice?.toFixed(2)}/CH $</strong> était ${price?.toFixed(2)}/CH $`,
        'cardLinkedSceneText': 'Obtenez 50 points Scène+ pour chaque 50 $ dépensés sur les achats admissibles (avant taxes) ',
        'cardNotLinkedSceneText': 'Ajoutez votre carte Scène+ pour accumuler des points sur les commandes de plus de 50 $ (avant taxes) ',
        "quantUnshippable": "Quantité non disponible pour l’expédition",
        'quantUnshippableContent': "Nous sommes désolés! Nous ne pouvons pas expédier la quantité sélectionnée à votre domicile. Veuillez réduire la quantité jusqu'à ce que l'expédition à domicile apparaisse comme une option pour continuer.",
    };

    let cartData = false;
    let cartSummary = JSON.parse(localStorage.hh_cart_summary || '{}');
    let panelIsOpen = false;
    let panelType = 'cart';
    let fetching = false;
    let preferredStore = localStorage.preferredStore ? JSON.parse(localStorage.preferredStore) : false;
    let urlPath = window.location.pathname.split('/');

    // loyalty variables
    let promotionData = {};
    let storeSceneEnabled = false;
    let showLoyaltyService = false;
    let userLoyaltyEnabled = false;
    let useLoyaltyService = dataset.useLoyaltyService || false;
    let displayLoyaltyToEndUser = dataset.displayLoyaltyToEndUser || false;
    let isLoyaltyEligibleItem = false;
    let sceneSubtotal = 0;

    // add to cart variables
    let addedCartItem = [];
    let categoryArr = [];
    let displayWarningAddToCart = false;
    let showModalWarning = false;
    let cartContinue = true;
	let addedQuantity = 0;

    // Loyalty Functions
    // check incognito flags and show loyalty features to end user
    function checkIncognitoFlags() {
        if (useLoyaltyService) {
            const urlParams = new URLSearchParams(window.location.search);
            const showLoyalty = urlParams.get('showLoyalty');
            showLoyaltyService = displayLoyaltyToEndUser || !!showLoyalty;
        }
    }

    async function isUserLoyaltyEnabled() {
        // get account Id
        let userData = getUserCookie();
        if (!userData || userData.accountId == undefined){
            userLoyaltyEnabled = false;
            return 
        }
        // get sceneEnabled attribute value
        let response = await fetch(`/_data/${lang}/${userData.accountId}/loyaltyEnabled`);
        userLoyaltyEnabled = await response.json();
    }

    async function getStoreSceneAttributeValue() {
        if (!preferredStore.code) return;
        let response = await fetch(`/_data/${lang}/store/${preferredStore.code}`);
        let res = await response.json();
        let preferredStoreAttr = res?.attributes;
        if (preferredStoreAttr) storeSceneEnabled = preferredStoreAttr.find(attribute => attribute.fullyQualifiedName == 'tenant~store-scene-enabled')?.values[0];  
    }

    // Add To Cart Functions
    function getUserCookie() {
        let user = 'user=';
        let cookie = decodeURIComponent(document.cookie).split(';').find(cookie => cookie.trim().startsWith(user));
        return cookie ? JSON.parse(cookie.trim().substring(user.length)) : '';
    }

    function getCategory(category) {
        if (category) {
            getCategory(category?.parentCategory);
            categoryArr.push(category?.content?.name);   
        }
    }

    async function getCartSummary() {
        try {
            let userData = getUserCookie();
            if (!userData || userData.userId == undefined) return false;
            let response = await fetch(`${decoupledUrl}/_api/${lang}/cartSummary/${userData.userId}?code=${preferredStore.code}`);
            cartSummary = await response.json();
            cartSummary.userId = userData.userId;
            localStorage.hh_cart_summary = JSON.stringify(cartSummary);
        } catch (error) {
            console.warn('getCartSummary error',error);
        }
    }

    async function getCart() {
        fetching = true
        try {
            // Get user cookies
            let userData = getUserCookie();
            if (!userData || userData.userId == undefined) return false;
            let response = await fetch(`/_api/${lang}/cart/${userData.userId}?code=${preferredStore.code}`);
            let json = await response.json();
            cartData = json.response;
            let cartItemsCount = cartData.items.reduce((prev,curr) => prev + curr?.quantity, 0);
            if (cartSummary && (cartItemsCount != JSON.parse(cartSummary?.totalQuantity))) await getCartSummary();
            promotionData = {
                cartPromotion: cartData.cartPromotion,
                thresholdStatus: json.threshold.status,
                thresholdAmount: json.threshold.balance
            }
            // Monetate addCartRows method
            const monetateCartItems = cartData.items.map(item => {
                return {
                    'productId': item.product.productCode,
                    'quantity': item.quantity,
                    'unitPrice': item.unitPrice.listAmount,
                    'currency': cartData.currencyCode
                }
            })
            if (window.monetateCollection && monetateCartItems.length) {
                const reset = window.monetateCollection.find(ele=> ele?.[0] == 'addCartRows')
                if (reset) {
                    window.monetateCollection.map(evt => {
                        if (evt?.[0] == 'addCartRows') {
                            evt[1] = monetateCartItems;
                        }
                    });
                } else {
                    window.monetateCollection.push(["addCartRows", monetateCartItems])
                }
                window.monetatePush()
            }
            // check if there is a loyalty eligible item in cart and get sceneSubtotal
            sceneSubtotal = 0
            isLoyaltyEligibleItem = false;
            cartData.items.forEach(item => {
                if (item.product && item.product.properties && item.product.properties.length > 0) {
                    const eligible = item.product.properties.find(prop => prop.attributeFQN === 'tenant~dynattribute-304');
                    if (!(eligible && eligible.values.length && (eligible.values[0].stringValue === (en ? 'Loyalty Earn Exemption' : 'Exempte du programme fidelite')))) {
                        sceneSubtotal += item.taxableTotal;
                        isLoyaltyEligibleItem = true;
                    }
					
					let lowPriceAttr = item?.product?.properties?.find(prop => prop.attributeFQN === 'Tenant~dynattribute-295');
					if (lowPriceAttr && lowPriceAttr.values.length) {
						item.isLockedInLowPrice = true;
					}
                }
            });
        } catch (error) {
            console.warn('getCart error',error);
        } finally {
            fetching = false;
        }
    }

    async function cartUpdateEventHandler() {
        try {
            await getCartSummary();
            await getCart();
            const salesForce = {
                cartRecoveryId: cartData?.id,
                products: cartData.items?.map(product => {
                    return {
                        id: product.product?.productCode,
                        price: product.product?.price?.salePrice || product.product?.price?.price,
                        quantity: product.quantity
                    }
                })
            };
            if (localStorage['hh_cartId'] !== cartData?.id) window.localStorage.setItem('hh_cartId', cartData?.id);
            window.dataLayer?.push({
                'event': 'salesForceAddToCart', 
                'salesForce': salesForce
            });
        } catch (error) {
            console.warn('CartUpdate Failed', error);
        }
    }

    async function addToCartHandler(e) {
		try {
			const productInfo = e.detail.productInfo
            const attributionToken = e.detail.attributionToken ?? null
			const buttonTitle = e.detail.buttonTitle
			if(e.detail.showModalWarning == 'true'){
				showModalWarning = true
			}else if(e.detail.showModalWarning == 'false'){
				showModalWarning = false
			}else showModalWarning = showModalWarning || false
			//showModalWarning = e.detail.showModalWarning || e.detail.showModalWarning == 'true' ? true : false
			const addToCartButton = e.detail.button.children[0]

			addToCartButton.classList.add('ButtonLoading')

            const showPanel = e.detail.showPanel == "false" ? false : true;
            const showSuccessMessage = e.detail.successMessage == "true" ? true : false;

			if(showModalWarning || showModalWarning == 'true') 	await waitModalWarning()

			if (cartContinue) {
				const res = await addToCart(productInfo)
				if(res?.error) return 0
				addToCartButton.disabled = true;
				addToCartButton.classList.remove('ButtonLoading')
				addToCartButton.querySelector('span').innerHTML = `<img class="Icon" alt="Added to Cart" src="https://homehardware.sirv.com/hh/icons/Icon_ConfirmationButton.black.svg" />${productInfo.length > 1 ? en ? 'Added All To Cart' : 'Ajouté tout au panier' : en ? 'Added To Cart' : 'Ajouté au panier'}`						

				setTimeout(()=> {
					addToCartButton.classList.remove('ButtonLoading')
					addToCartButton.disabled = false;
					addToCartButton.querySelector('span').innerHTML = buttonTitle
				}, 3000);
				if(showPanel){
                    openPanel(true);
                }
				getCart();
				sendDataLayerObject({attributionToken});
                if(showSuccessMessage) {
                    window.dispatchEvent(new CustomEvent('showSuccessMessage', {detail: productInfo}));
                }
			}
			addToCartButton.classList.remove('ButtonLoading')
		} catch (error) {
			const addToCartButton = e.detail.button.children[0]
			addToCartButton.classList.remove('ButtonLoading')
			console.warn(error)
		} finally {
            cartContinue = true
        }
    }

	const waitModalWarning = () => {
		return new Promise((resolve) => {
			const clearIntervalId = setInterval(() => {
			if (!showModalWarning) {
				clearInterval(clearIntervalId);
				resolve();
			}
			}, 100);
		});
	};

    async function addToCart(productInfo) {
        try{
            const focusOutEvt = new Event('focusOutEvt', {
                bubbles: false,
                cancelable: false
            });
            window.dispatchEvent(focusOutEvt)
            let shippingStatusEle = document.querySelector("label[data-shipping-status]")
            if(shippingStatusEle && shippingStatusEle.dataset.shippingStatus == 'No Rates' && method=='Ship') {
                displayWarningAddToCart = true
                throw 'disabling add to cart'            
            }
            const userId = getUserCookie().userId;
            let response = await fetch(`/_api/${lang}/cart/new/${userId}`, {
                method: 'POST',
                body: JSON.stringify({
                    productInfo: JSON.stringify(productInfo),
                    fulfillmentLocationCode: preferredStore.code,
                    fulfillmentLocationName: preferredStore.name,
                    ehf: preferredStore.ehf,
                    stateOrProvince: preferredStore?.address?.stateOrProvince
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            response = await response.json();
            window.dispatchEvent(new Event('cartUpdate'));
            addedCartItem = response?.response;
			addedCartItem?.forEach(item => {
                if (item.product && item.product.properties && item.product.properties.length > 0) {
					let lowPriceAttr = item?.product?.properties?.find(prop => prop.attributeFQN === 'Tenant~dynattribute-295');
					if (lowPriceAttr && lowPriceAttr.values.length) {
						item.isLockedInLowPrice = true;
					}
                }
			});
            return response;
        } catch(err) {
            console.warn('AddToCart error', err);
            return {
                error: err
            }
        }
    }

    // Panel Control Functions
    function openPanel(addToCart=false) {
        panelType = addToCart ? 'addToCart' : 'cart';
        // get cart data if there is none when opening panel
        if (!cartData) getCart();
		addedQuantity = addedCartItem[0] ? addedCartItem[0]?.quantity : 0; 
		if(panelType == 'addToCart'){
			cartSummary && window.dataLayer.push({
				'event' : 'addToCartDropdownView',
				'itemQuantity' : addedQuantity ? addedQuantity : 0
			});
		} else {
			cartSummary && window.dataLayer.push({
				'event' : 'cartDropdownView',
				'cartQuantity' : cartSummary?.itemCount
			});
		}

        panelIsOpen = true;
        isUserLoyaltyEnabled();
        getStoreSceneAttributeValue();
        checkIncognitoFlags();
    }
    function closePanel() {
		if(panelType == 'addToCart'){
			cartSummary && panelIsOpen && window.dataLayer.push({
				'event' : 'addToCartDropdownClick',
				'itemQuantity' : addedQuantity ? addedQuantity : 0,
				'cartCTA' : 'Close/Continue Shopping',
			});
		} else {
			cartSummary && panelIsOpen && window.dataLayer.push({
				'event' : 'cartDropdownClick',
				'cartQuantity' : cartSummary?.itemCount,
				'cartCTA' : 'Close/Continue Shopping',
			});
		}
        panelIsOpen = false;
    }

    // Data Layer Functions
    // add to data layer
    function addDataLayer(type, quantity=false) {
        try {
            cartSummary = localStorage.getItem('hh_cart_summary') ? JSON.parse(localStorage.getItem('hh_cart_summary')) : false;
            if(!cartSummary) return;
			if( type == 'View Cart' || type == 'Checkout' ){
				if(panelType == 'addToCart'){
					window.dataLayer.push({
						'event' : 'addToCartDropdownClick',
						'itemQuantity' :  addedQuantity ? addedQuantity : 0,
						'cartCTA' : type,
					});
				} else {
					window.dataLayer.push({
						'event' : 'cartDropdownClick',
						'cartQuantity' : quantity || cartSummary?.itemCount,
						'cartCTA' : type,
					});
				}
			}
        } catch (error) {
            console.warn('addDataLayer Failed', error);
        }
    }

    // add data layer after 'Add to Cart' button
    function sendDataLayerObject({attributionToken=null}) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(function() {
            this.reset();
        });

		addedCartItem.forEach(item => {
			categoryArr = [];
			getCategory(item?.product?.categories);
			let categories = categoryArr.join("/");
			let timelines = document.querySelector('[data-shipping-timeline]') ? document.querySelector('[data-shipping-timeline]').getAttribute("data-shipping-timeline") : undefined;
			let productPrice = (item?.product?.price?.salePrice ? item?.product?.price?.salePrice :  item?.product?.price?.price) || 0;
			let brand = item?.product?.properties.filter(attribute => attribute?.attributeFQN === 'tenant~brand-desc');
			brand = brand[0].values[0].value;
            console.log('weeee',{
				'event': 'addToCart',
                'searchEngine': localStorage.ab_search,
				'metric4': productPrice * item.quantity,
                'attributionToken': attributionToken,
				'ecommerce': {
					'currencyCode': 'CAD',
					'add': {
					'products': [{
						'name': item?.product?.name,
						'id': item.product.productCode,
						'price': productPrice.toString(),
						'brand': brand,
						'category': categories, 
						'quantity': item.quantity
						}]
					}
				},
				'fulfillmentMethod': item.fulfillmentMethod == 'Ship' ? 'Ship to Home' : 'FREE In-Store Pick-up',
				'sthTimeline': timelines ? `${timelines} days` : undefined
			});
			window.dataLayer.push({
				'event': 'addToCart',
                'searchEngine': localStorage.ab_search,
				'metric4': productPrice * item.quantity,
                'attributionToken': attributionToken,
				'ecommerce': {
					'currencyCode': 'CAD',
					'add': {
					'products': [{
						'name': item?.product?.name,
						'id': item.product.productCode,
						'price': productPrice.toString(),
						'brand': brand,
						'category': categories, 
						'quantity': item.quantity
						}]
					}
				},
				'fulfillmentMethod': item.fulfillmentMethod == 'Ship' ? 'Ship to Home' : 'FREE In-Store Pick-up',
				'sthTimeline': timelines ? `${timelines} days` : undefined
			});
		})
    }

    async function flyerAddToCart(e) {
        try {
            const productCode = e.detail.cartOption.id
            const productInfo = [{
                "productCode": `${productCode}`,
                "quantity": 1,
                "method": "Pickup"
            }]
            const res = await addToCart(productInfo);
            if(res?.error) return 0;
            openPanel(true);
            getCart();
            sendDataLayerObject();
        } catch (error) {
			console.warn(error);
        }
    }

    // get cart summary if there is none
    if (!localStorage.hh_cart_summary) getCartSummary();

    if(urlPath.includes('checkout') && urlPath[urlPath.length - 1]?.toLowerCase() == 'confirmation') {
        window.localStorage.removeItem('hh_cart_summary');
        cartSummary = {};
    }

    window.addEventListener('cartUpdate', cartUpdateEventHandler, false);
    window.addEventListener('hhPanelClose', closePanel, false);
    window.addEventListener('cartReset', getCartSummary, false);
    window.addEventListener('addToCart', addToCartHandler, false);
    window.addEventListener('flyerAddToCart', flyerAddToCart, false);

    $: document.querySelector('hh-panel').hidden = !panelIsOpen;
</script>


{#if cartSummary.hasOwnProperty("totalQuantity")}
    <a href="{kiboUrl}/{lang}/cart" on:click|preventDefault={() => openPanel()}>
        <img src={"https://homehardware.sirv.com/hh/icons/icon.cart.svg"} alt={en ? "Shopping Cart Icon" : "Icône du panier"} class="icon" width="0" height="0" />
        <div class="cart-count" data-lang="{lang}">{cartSummary.totalQuantity}</div>
        {en ? "Cart" : "Panier"}
    </a>
{:else}
    <a href="{kiboUrl}/{lang}/cart">
        <img src={"https://homehardware.sirv.com/hh/icons/icon.cart.svg"} alt={en ? "Shopping Cart Icon" : "Icône du panier"} class="icon" width="0" height="0" />
        <div class="cart-count" data-lang="{lang}">0</div>
        {en ? "Cart" : "Panier"}
    </a>
{/if}

{#if panelIsOpen}
    <Panel
        panelItems = {panelType == 'cart' ? cartData.items : addedCartItem}
        lang = {lang}
        closePanel = {closePanel}
        promotionData = {promotionData}
        panelType = {panelType}
        cartPanelLoading = {panelType == 'cart' ? fetching : false}
        addDataLayer = {addDataLayer}
        cartData = {cartData}
        cartSummary = {cartSummary}
        storeSceneEnabled = {storeSceneEnabled}
        isLoyaltyEligibleItem = {isLoyaltyEligibleItem}
        sceneSubtotal = {sceneSubtotal}
    />
    
{/if}

{#if displayWarningAddToCart}
    <Portal target="hh-modal" data-add-to-cart-warning>
        <h3 class="Center" data-add-to-cart-warning><img src="https://homehardware.sirv.com/hh/icons/Icon_RedExclamation.svg" alt="Exclamation" width="18" height="18"/>{Strings.quantUnshippable}</h3>
        <p data-add-to-cart-warning>{Strings.quantUnshippableContent}</p>
        <button class="Button ButtonSecondary" on:click="{() =>displayWarningAddToCart = false}">{en ? "Got it" : "Compris"}</button>
    </Portal>
{/if}

<!-- {#if showModalWarning}
    <Portal target="hh-modal">
        <section class="Center cart-warning-modal">
            <h2 class="warning-title"><img src="https://homehardware.sirv.com/hh/icons/Icon_RedExclamation.svg" alt="addToCartError" style="height: 1em; width: auto;"> {en ? "Please Note" : "Remarque"}</h2>
            <h4 style="color: var(--hh-dark-grey);">{en ? "Items that are not available or out of stock will not be added to your cart." : "Les articles qui ne sont pas disponibles ou qui sont en rupture de stock ne seront pas ajoutés à votre panier."}</h4>
            <section class="Center">
				<button class="Button ButtonSecondary" on:click={() => {showModalWarning=false; cartContinue=false}}>{en ? "Go Back" : "Retour"}</button>
				<button class="Button" on:click={modalContinueHandler}>{en ? "Continute" : "Continuer"}</button>
			</section>
        </section>

		<h3 class="Center"><img src="https://homehardware.sirv.com/hh/icons/Icon_RedExclamation.svg" alt="addToCartError" width="20" height="20"> {en ? "Please Note" : "Remarque"}</h3>
		<p class="Center">
			{en ? "Items that are not available or out of stock will not be added to your cart." : "Les articles qui ne sont pas disponibles ou qui sont en rupture de stock ne seront pas ajoutés à votre panier."}
		</p>
		<fieldset class="ButtonGroup Center">
			<button class="Button ButtonSecondary" on:click={() => {showModalWarning=false; cartContinue=false}}>{en ? "Go Back" : "Retour"}</button>
			<button class="Button" on:click={() => {showModalWarning=false; cartContinue=true}} >{en ? "Continue" : "Continuer"}</button>
		</fieldset>
    </Portal>
{/if} -->


<style>
    .cart-count {
        color: #000;
        display: inline-block;
        border-radius: 50%;
        background: #fff;
        text-align: center;
        position: absolute;
        right: -14%;
        top: -4%;
        z-index: 1;
        font-size: 12px;
        width: 13.29px;
        height: 13.29px;
        line-height: 15px;
    }
    .cart-count[data-lang="fr"] {
        right: 5px;
    }

   

    @media (max-width: 600px) {
        .cart-count,
        .cart-count[data-lang="fr"] {
            top: -26%;
            right: -50%;
            width: 11px;
            height: 11px;
            font-size: 10px;
            line-height: 13px;
        }
    }
    @media (min-width:600px) and (max-width:800px) {
        .cart-count,
        .cart-count[data-lang="fr"] {
            right: 0;
            top: -5px;
            width: 11px;
            height: 11px;
            font-size: 10px;
            line-height: 13px;
        }
    }


/** 
    .cart-warning-modal {
        display: flex;
        flex-direction: column;
        gap: calc(var(--gap)/2);
    }
    .warning-title {
        display: flex;
        justify-content: center;
        gap: calc(var(--gap)/2);
    }
**/
</style>